import React, { useEffect, useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import SettingsIcon from "@mui/icons-material/Settings";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MyTable from "./Table";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PasswordIcon from "@mui/icons-material/Password";
import AddBoxIcon from "@mui/icons-material/AddBox";
import ApiConfig from "../../common/config/ApiConfig";
import {
  groupPermissions,
  getPermissionCategoryLabelKey,
  getPermissionLabel,
} from "../../common/utils/permissionCategories";
import { useLanguage } from "../../common/i18n/LanguageContext";

export default function CustomizedTables({ externalReload }) {
  const { t } = useLanguage();
  const [member, setMember] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [username, setUsername] = useState();
  const [userid, setUserid] = useState();

  const [reload, setReload] = useState(0);
  const [status, setStatus] = useState(1);
  const [permission, setPermission] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const MemberGet = async () => {
    const result = await ApiConfig.get("/getsubaccount");
    if (result.resCode !== 200) {
      toast.error(result.message || t("common_load_error"), {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    setMember(result.data);
  };

  useEffect(() => {
    MemberGet();
    // eslint-disable-next-line
  }, [reload, externalReload]);

  const handleClickOpen = async (id, username) => {
    setOpen(true);
    setUsername(username);
    setUserid(id);

    const result = await ApiConfig.get("/permissions");
    if (result.resCode !== 200) {
      toast.error(result.message || t("subaccount_permissions_fetch_error"), {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    setPermissions(result.data);
    const memberData = member.find((p) => p.id === id);

    setPermission(
      (memberData?.permissions || [])
        .filter((p) => p.status === 1)
        .map((p) => p.PermissionID),
    );
  };

  const handleUpdate = () => {
    setOpen(false);
    Swal.fire({
      title: t("subaccount_update_confirm_title"),
      text: `${t("subaccount_update_confirm_text")} : ${username}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common_confirm"),
      cancelButtonText: t("common_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = {
          UserID: userid,
          permissions: permission.map((p) => {
            return { PermissionID: p, status: 1 };
          }),
        };
        ApiConfig.post("/updateuserpermissions", formData)
          .then((result) => {
            if (result.resCode === 200) {
              toast.success(t("subaccount_update_success"), {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              setReload(reload + 1);
              handleClose();
            } else {
              toast.error(result.message || t("subaccount_update_error"), {
                position: "top-right",
                autoClose: 3000,
              });
            }
          })
          .catch(() => {
            toast.error(t("subaccount_update_error"), {
              position: "top-right",
              autoClose: 3000,
            });
          });
      }
    });
  };

  const handleClose = () => {
    setOpen(false);
    setUsername();
    setUserid();
  };

  // #region password edit

  const [openeditpassword, setOpeneditpassword] = React.useState(false);
  const [password, setPassword] = useState();
  const [id, setId] = useState();

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleClickOpenpassword = (username, id) => {
    setUsername(username);
    setId(id);
    setOpeneditpassword(true);
  };

  const handleClosepassword = () => {
    setOpeneditpassword(false);
    setUsername();
    setPassword();
    setId();
  };

  const handleChangepassword = (event) => {
    setPassword(event.target.value);
  };

  const handleUpdatepassword = (password) => {
    const jsonid = {
      id: id,
      Password: password,
    };

    Swal.fire({
      title: t("subaccount_change_password_title"),
      text: t("subaccount_change_password_text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("common_confirm"),
      cancelButtonText: t("common_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        ApiConfig.post("/subpasswordchange", jsonid)
          .then((result) => {
            if (result.resCode === 200) {
              toast.success(t("membertable_change_password_success"), {
                position: "top-right",
                autoClose: 3000,
              });
            } else {
              toast.error(
                result.message || t("membertable_change_password_error"),
                {
                  position: "top-right",
                  autoClose: 3000,
                },
              );
            }
          })
          .catch(() => {
            toast.error(t("membertable_change_password_error"), {
              position: "top-right",
              autoClose: 3000,
            });
          });
      }
    });

    handleClosepassword(); // Close the password dialog regardless of the user's choice
  };

  const handlepermission = (id) => {
    if (permission.includes(id)) {
      setPermission(permission.filter((p) => p !== id));
    } else {
      setPermission([...permission, id]);
    }
  };

  const handleSelectAllPermissions = () => {
    if (permission.length === permissions.length) {
      setPermission([]);
    } else {
      setPermission(permissions.map((item) => item.id));
    }
  };

  const handleDeleteagent = (agent, id) => {
    // Show confirmation dialog
    Swal.fire({
      title: t("subaccount_delete_confirm_title"),
      text: `${t("subaccount_delete_confirm_text_prefix")} ${agent}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common_yes"),
      cancelButtonText: t("common_no"),
    }).then((result) => {
      if (result.isConfirmed) {
        // Delete the agent
        ApiConfig.post("/deletesubaccount", { id })
          .then((result) => {
            if (result.resCode === 200) {
              toast.success(t("subaccount_delete_success"));
              window.location.reload();
            } else {
              toast.error(result.message || t("common_delete_error"));
            }
          })
          .catch(() => {
            toast.error(t("common_delete_error"));
          });
      }
    });
  };

  // #endregion

  const memberColumns = [
    {
      Header: t("membertable_col_no"),
      align: "center",
      widthClass: "w-[50px]",
      width: 50,
      Cell: ({ row }) => (
        <span className="font-bold text-[9px] md:text-[11px]">
          {row.index + 1}
        </span>
      ),
    },
    {
      Header: t("login_username_label"),
      accessor: "username",
      align: "left",
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
      widthClass: "w-1/6", // Adjust the width class as needed
    },
    {
      Header: t("subaccount_status_label"),
      accessor: "status",
      align: "left",
      Cell: ({ value }) => (
        <span
          className={`font-bold text-[9px] md:text-[11px] ${value === 1 ? "text-green-500" : "text-red-500"}`}
        >
          {value === 1
            ? t("subaccount_status_active")
            : t("subaccount_status_inactive")}
        </span>
      ),
      widthClass: "w-1/6", // Adjust the width class as needed
    },
    {
      Header: t("subaccount_col_last_login_time"),
      accessor: "login_date",
      align: "right",
      Cell: ({ value }) => (
        <span className="font-bold text-[9px] md:text-[11px]">{value}</span>
      ),
      widthClass: "w-1/6",
    },
    {
      Header: t("subaccount_col_last_login_ip"),
      accessor: "ip",
      align: "right",
      Cell: ({ value }) => (
        <span className="text-[9px] md:text-[11px]">{value}</span>
      ),
      widthClass: "w-1/6",
    },
    {
      Header: t("membertable_col_manage"),
      accessor: "id",
      align: "center",
      Cell: ({ value, row }) => (
        <div className="flex justify-center items-center flex-row space-x-1">
          <button
            className="bg-blue-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
            onClick={(e) => handleClickOpen(value, row.original.username)}
          >
            <SettingsIcon sx={{ fontSize: 16 }} />
          </button>
          <button
            className="bg-yellow-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
            onClick={(e) =>
              handleClickOpenpassword(row.original.username, row.original.id)
            }
          >
            <PasswordIcon sx={{ fontSize: 16 }} />
          </button>
          <button
            onClick={() =>
              handleDeleteagent(row.original.username, row.original.id)
            }
            className="bg-red-400 text-white hover:bg-slate-600 hover:text-black p-1 rounded flex items-center justify-center"
          >
            <DeleteForeverIcon sx={{ fontSize: 16 }} />
          </button>
        </div>
      ),
      widthClass: "w-1/6",
    },
  ];

  return (
    <div>
      <TableContainer component={Paper}>
        <MyTable columns={memberColumns} data={member} search={""} />
      </TableContainer>
      {openeditpassword && (
        <div>
          <Dialog
            open={openeditpassword}
            onClose={handleClosepassword}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { width: "80%", maxWidth: "100%", margin: 0 },
            }}
          >
            <DialogTitle
              className="text-white bg-brand-blue-800"
              id="alert-dialog-title"
            >
              {t("membertable_change_password_dialog_title_prefix")} {username}
            </DialogTitle>
            <DialogContent>
              <div className="flex w-full flex-col p-2 space-y-2">
                <div className="flex w-[100%] flex-col space-y-2 p-2 rounded-xl border border-[1px]">
                  {/* Content */}
                  <span>{t("membertable_new_password_prompt")}</span>

                  <FormControl sx={{ m: 1, width: "100%" }} variant="standard">
                    <InputLabel htmlFor="standard-adornment-password">
                      {t("login_password_label")}
                    </InputLabel>
                    <Input
                      id="standard-adornment-password"
                      type={showPassword ? "text" : "password"}
                      autoComplete="off"
                      onChange={(e) => handleChangepassword(e)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
              </div>
            </DialogContent>

            <DialogActions>
              <button
                onClick={() => handleUpdatepassword(password)}
                className="bg-gradient-to-b from-brand-gold-300 via-brand-gold-400 to-brand-gold-600 text-brand-ink-onGold border border-brand-gold-200 shadow-gold hover:brightness-105 mr-1 font-bold py-2 px-4 mr-1 rounded"
              >
                <SaveAltIcon /> {t("membertable_save")}
              </button>
              <button
                onClick={handleClosepassword}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              >
                {t("common_cancel")}
              </button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {open && (
        <div>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="xs"
          >
            <div className="App">
              <form onSubmit={handleUpdate}>
                <DialogTitle
                  className="text-white bg-brand-blue-800"
                  id="alert-dialog-title"
                >
                  {t("subaccount_edit_dialog_title")} {username}
                </DialogTitle>
                <DialogContent>
                  <div className="grid grid-cols-2 p-2 mt-2 border-[1px] bg-amber-100 border-slate-400 rounded-lg gap-4">
                    <div>
                      <label className="block mb-1 font-bold">
                        {t("subaccount_status_label")}
                      </label>
                      <select
                        value={status}
                        onChange={(e) => setStatus(Number(e.target.value))}
                        name="status"
                        id="status"
                      >
                        <option value={1}>
                          {t("subaccount_status_active")}
                        </option>
                        <option value={0}>
                          {t("subaccount_status_inactive")}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-rows p-2 mt-2 border-[1px] bg-amber-100 border-slate-400 rounded-lg gap-4">
                    <label htmlFor="bank" className="mb-1 font-bold">
                      {t("subaccount_permissions_label")}
                    </label>

                    <label>
                      <input
                        type="checkbox"
                        className="mr-2 accent-blue-500"
                        checked={
                          permissions.length > 0 &&
                          permission.length === permissions.length
                        }
                        onChange={handleSelectAllPermissions}
                      />
                      {t("subaccount_select_all")}
                    </label>

                    <div className="flex flex-col gap-2 max-h-[50vh] overflow-y-auto pr-1">
                      {Object.entries(groupPermissions(permissions)).map(
                        ([category, items]) => (
                          <div
                            key={category}
                            className="grid grid-cols-2 p-2 mt-2 border-[1px] bg-amber-100 border-slate-400 rounded-lg gap-4"
                          >
                            <label className="col-span-2 block mb-1 font-bold">
                              {t(getPermissionCategoryLabelKey(category))}
                            </label>
                            {items.map((item) => (
                              <label key={item.id}>
                                <input
                                  type="checkbox"
                                  className="mr-2 accent-blue-500"
                                  checked={permission.includes(item.id)}
                                  value={item.id}
                                  onChange={() => handlepermission(item.id)}
                                />
                                {getPermissionLabel(item, t)}
                              </label>
                            ))}
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </DialogContent>
                <DialogActions>
                  <button
                    type="submit"
                    className="bg-gradient-to-b from-brand-gold-300 via-brand-gold-400 to-brand-gold-600 text-brand-ink-onGold border border-brand-gold-200 shadow-gold hover:brightness-105 mr-1 font-bold py-2 px-4 mr-1 rounded"
                  >
                    <AddBoxIcon /> {t("membertable_save")}
                  </button>
                  <button
                    onClick={handleClose}
                    className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                  >
                    {t("common_cancel")}
                  </button>
                </DialogActions>
              </form>
            </div>
          </Dialog>
        </div>
      )}
    </div>
  );
}
